import memberRepository from "../../repository/MemberRepository";
import {SiteBunnyError, toSiteBunnyError} from "../../error";
import {useQuery} from "@tanstack/react-query";
import {MemberSummary} from "../../model/member";
import {User} from "../../model/user";

const getData = async (userId: string) => {
    try {
        const { data } = await memberRepository.find_with_user_id(userId);
        return data.result;
    } catch (e) {
        throw toSiteBunnyError(e);
    }
}

const useUserMembers = (profile: User | undefined) => {
    return useQuery<MemberSummary[], SiteBunnyError>({
        queryKey: ['userMembers', profile?._id],
        queryFn: async () => getData(profile!._id),
        enabled: !!profile,
        retry: false,
        suspense: false,
    })
}

export default useUserMembers;
